import { CodeMirrorMode } from './codemirror-mode.enum';

export interface CodeMirrorObjectMode {
  name: CodeMirrorMode;
  json: boolean;
}
